export default __webpack_public_path__ + "static/media/red_dot.c4d5402b.svg";